import AutoSaveHandler from "../../../../spine-appkit-vue/src/utils/handler/auto-save-handler";

Vue.asyncComponent('cms-auto-save-badge',{
    data() {
        return {
            refresh: null
        }
    },
    props: {
        objectId: {
            type: String,
            required: true
        },
        bundleId: {
            type: String,
            required: true
        },
        definitionId: {
            type: String,
            required: true
        },
    },
    computed: {
        id() {
            return this.definitionId + '-' + this.bundleId + '-' + this.objectId;
        },
        show() {
            // we pass the refresh token to make sure this computed prop updates when the token changes
            return (new AutoSaveHandler(this.id, {refresh: this.refresh})).getEntry();
        }
    },
    methods: {
        /**
         * Check if the autosave has been updated
         *
         * @param event
         * @return {boolean}
         */
        checkAutoSaveUpdated(event) {
            if(event.key !== (this.id + '-auto-save')) {
                return false;
            }

            // if the auto save has been changed we update the refresh token
            this.refresh = new Date();
        }
    },
    created() {
        window.addEventListener('storage', this.checkAutoSaveUpdated);
    },
    beforeDestroy() {
        window.removeEventListener('storage', this.checkAutoSaveUpdated)
    }
}, 'cms/grid/cms-auto-save-badge.html');
